import { PrimeReactPTOptions } from "primereact/api";
import { SplitButtonPassThroughMethodOptions } from "primereact/splitbutton";
import { classNames } from "primereact/utils";

export const splitbutton: PrimeReactPTOptions["splitbutton"] = {
  root: ({ props }: SplitButtonPassThroughMethodOptions) => ({
    className: classNames("inline-flex items-center relative", "rounded-md", {
      "shadow-lg": props.raised,
    }),
  }),
  button: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    root: ({ parent, props }: any) => ({
      className: classNames("rounded-r-none border-r-0", {
        "rounded-l-full": parent.props.rounded,
        "pr-1": props.severity === "secondary",
      }),
    }),
    icon: ["mr-2"],
  },
  menu: {
    root: {
      className: ["outline-none m-0  min-w-[150px] bg-white list-none shadow"],
    },
    menuItem: ["bg-white p-2 px-4 hover:bg-rdc-primaryLight"],
    icon: "mr-4",
  },
  menuList: ["relative"],
  menuButton: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    root: ({ parent, props }: any) => ({
      className: classNames("rounded-l-none", {
        "rounded-r-full": parent.props.rounded,
        "px-2": props.severity === "secondary",
      }),
    }),
    label: ["hidden"],
  },
};
